export default {"src":"/_next/static/media/agrs.2b52b60e.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};